import React, { useEffect, useState } from "react";
import "../../assets/scss/styles.scss";
import { SearchBarCommon } from "./search-bar-common";
import { useSessionStorage } from "../../modules/useSessionStorage"


export const FACSearchBar = ({setOverlay, setShowContractors, setShowSearch, handleFilters, handleLocation, showFiltersMobile, setShowFiltersMobile}) => {

    const [ allTags, setAllTags ] = useSessionStorage('all-tags', [])
    const [ businessTypeTags, setBusinessTypeTags ] = useSessionStorage('business-type-tags', [])

    const getSelected = (isSelected, arr) => {
        return arr.filter(t => t.selected === isSelected) 
    }

    const selected = () =>  getSelected(true, allTags)
    const suggested = () => getSelected(false, allTags)

    const selectedBusinessTypes = () =>  getSelected(true, businessTypeTags)

    // for input values
    const [ searchTag, setSearchTag ] = useState('')
    const [ searchLocation, setSearchLocation ] = useSessionStorage('search-location', '');


    /* go ahead show the landing page search result */
    useEffect(() => {
        const searchAfterRedirect = () => {
            if (allTags.length > 0 || searchLocation.length > 0 || businessTypeTags > 0) {
                handleSearch();
            }
        }
        searchAfterRedirect();
    }, [])

        //Get the selected tags as array
    const getTagsArgs = () => selected().map(({title}) => title);

    //Get the selected business type tags as array
    const getBusinessTypeTagsArgs = () => selectedBusinessTypes().map(({title}) => title);

    //return filter object for service and business type"tags" that combines them
    const getCombinedTagsFilter = () => {
        return {
            type: "tags",
            args: [...getTagsArgs(), ...getBusinessTypeTagsArgs()]
        };
    };

    const handleSearch = (location, clearFilter) => {
        const activeFilters = !clearFilter ? [getCombinedTagsFilter()] : [{type:"tags", args:""}];
        handleFilters(activeFilters);
        const currentLocation = clearFilter ? '' : location || searchLocation
        handleLocation(currentLocation);
    }

    return <SearchBarCommon 
        allTags={allTags}
        setAllTags={setAllTags}
        businessTypeTags={businessTypeTags}
        setBusinessTypeTags={setBusinessTypeTags}
        selected={selected()}
        selectedBusinessTypes={selectedBusinessTypes()}
        suggested={suggested()}
        searchTag={searchTag}
        setSearchTag={setSearchTag}
        searchLocation={searchLocation}
        setSearchLocation={setSearchLocation}
        handleSearch={handleSearch}
        searchBtn="Update location"
        setOverlay={setOverlay}
        setShowContractors={setShowContractors}
        setShowSearch={setShowSearch}
        showFiltersMobile={showFiltersMobile}
        setShowFiltersMobile={setShowFiltersMobile}
    />

}
